import { Component, Input, OnInit } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
	selector: 'checklist-progress-bar',
	templateUrl: './checklist-progress-bar.component.html',
	styleUrls: ['./checklist-progress-bar.component.scss'],
	imports: [NgStyle],
})
export class ChecklistProgressBarComponent implements OnInit {
	@Input() percentage: number = 0;

	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}
}
